import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  image: {
    width: 80,
    height: 80,

    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`,

    objectFit: 'cover',
    borderRadius: '50%',
  },
  imageIconWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 80,
      height: 80,

      borderRadius: '50%',
      border: `2px dashed ${theme.palette.custom.grey2}`,
    },
  },
  imageIcon: {
    width: 24,
    height: 24,
  },

  mobileIconWrapper: {
    marginBottom: SPACES.xxl,

    display: 'flex',
    gap: SPACES.xxl,
    alignItems: 'center',
  },
}))

export { useStyles }
